<template>
    <div class="container">
        <div class="row">
            <div class="col-md-16 col-md-offset-4">
                <form class="form-horizontal" @submit.prevent="submit" style="margin-top: 100px">
                    <div class="text-center" style="margin-bottom: 20px">
                        <img src="/img/logo.png">
                    </div>

                    <div class="panel panel-default panel-login panel-top-bordered">
                        <div class="panel-body">
                            <email-form-group
                                    v-model="data.email"
                                    name="email"
                                    label="Email"
                            ></email-form-group>

                            <password-form-group
                                    v-model="data.password"
                                    name="password"
                                    label="Password"
                            ></password-form-group>

                            <hr>

                            <submit-form-group :links="[{url: '/passwords/reset', label: 'Forgot your password?'}]">
                                <button type="submit" class="btn btn-black">
                                    <i class="fa fa-lock"></i> Login
                                </button>
                            </submit-form-group>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import http from '@/http'
    import notify from '@/notify'
    import store from '@/store'
    import EmailFormGroup from '@/vendor/forms/FormGroups/Horizontal/Email'
    import PasswordFormGroup from '@/vendor/forms/FormGroups/Horizontal/Password'
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'

    export default {
        components: {EmailFormGroup, PasswordFormGroup, SubmitFormGroup},

        data() {
            return {
                data: {
                    email: '',
                    password: ''
                },
                shared: store
            }
        },

        methods: {
            submit() {
                axios.post('/api/v1/tokens', {grant: 'user', ...this.data})
                    .then(response => {
                        this.shared.token = response.data.data.token

                        localStorage.setItem('token', response.data.data.token)

                        this.getCredentials()
                    })
                    .catch(error => {
                        notify.error(error.response.data.message)
                    })
            },

            getCredentials() {
                http.get('/api/v1/me')
                    .then(response => {
                        this.shared.user = response.data.data

                        localStorage.setItem('user', JSON.stringify(response.data.data))

                        notify.success('Welcome back!')

                        this.$router.push('/')
                    })
            }
        }
    }
</script>
